import useTranslation from 'next-translate/useTranslation';

import { useMainModalSmallScreenLayout } from './useMainModalSmallScreenLayout';

/**
 * Returns the skip-step action label: short copy on narrow viewports, full copy otherwise.
 */
export function useSkipStepButtonLabel(): string {
  const { t } = useTranslation('onboarding');
  const isSmallScreen = useMainModalSmallScreenLayout();

  return t(isSmallScreen
    ? 'invite_members_step.skip_btn_short'
    : 'invite_members_step.skip_btn');
}
